// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'automation-call';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M4.5 6 1.692 9.005A.726.726 0 0 0 1.5 9.5c0 .185.069.363.192.495L4.5 13m9-7 2.808 3.005c.123.131.192.31.192.495a.726.726 0 0 1-.192.495L13.5 13M9.997 4 6.06 9.098a.297.297 0 0 0-.037.296c.02.048.05.088.091.117a.24.24 0 0 0 .136.045H8V14l3.94-5.099a.298.298 0 0 0 .037-.296.262.262 0 0 0-.091-.116.238.238 0 0 0-.136-.045H9.997z'
  />
);

export const viewBox = '0 0 18 18';
